export default __webpack_public_path__ + "static/media/Picture1.775cd044.png";